/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The filter of business object data notification registration
 */
export interface BusinessObjectDataNotificationFilter { 
    /**
     * The namespace of the business object definition
     */
    namespace: string;
    /**
     * The business object definition name
     */
    businessObjectDefinitionName: string;
    /**
     * The business object format usage
     */
    businessObjectFormatUsage?: string;
    /**
     * The business object format file type
     */
    businessObjectFormatFileType?: string;
    /**
     * The business object format version
     */
    businessObjectFormatVersion?: number;
    /**
     * The storage name
     */
    storageName?: string;
    /**
     * The new business object data status
     */
    newBusinessObjectDataStatus?: string;
    /**
     * The old business object data status
     */
    oldBusinessObjectDataStatus?: string;
}
